module.exports = __webpack_public_path__ + "img/67.e3b3b1d0.png";